(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ve-nav-pods"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ve-pods[data-ve-filter]').forEach(function (nav) {
    if (nav.dataset.veFilterInit) return;
    nav.dataset.veFilterInit = '1';

    var pods = nav.querySelectorAll('.ve-pods__pod');
    var busy = false;

    function handleFromHref(href) {
      var m = (href || '').match(/\/collections\/([^\/?#]+)/);
      return m ? m[1] : null;
    }

    /* Legacy support: hide/show pre-rendered [data-ve-fg-grid] grids if present */
    function showGrid(handle) {
      var found = false;
      document.querySelectorAll('[data-ve-fg-grid]').forEach(function (g) {
        if (g.getAttribute('data-ve-fg-grid') === handle) {
          g.hidden = false;
          found = true;
        } else {
          g.hidden = true;
        }
      });
      return found;
    }

    function setActive(pod) {
      pods.forEach(function (p) {
        p.classList.remove('ve-pods__pod--active');
        p.removeAttribute('aria-current');
      });
      pod.classList.add('ve-pods__pod--active');
      pod.setAttribute('aria-current', 'page');
    }

    function findSection(root, suffix) {
      var all = root.querySelectorAll('[id^="shopify-section-"]');
      for (var i = 0; i < all.length; i++) {
        if (all[i].id.slice(-suffix.length) === suffix) return all[i];
      }
      return null;
    }

    /* Replace the collection heading + main grid sections with ones from the fetched page */
    function swapFrom(doc) {
      var swapped = false;
      ['__section', '__main'].forEach(function (suf) {
        var cur = findSection(document, suf);
        var next = findSection(doc, suf);
        if (cur && next) {
          cur.replaceWith(next);
          swapped = true;
        }
      });
      return swapped;
    }

    pods.forEach(function (pod) {
      pod.addEventListener('click', function (e) {
        var href = pod.getAttribute('href');
        var handle = handleFromHref(href);
        if (!handle) return;

        /* Legacy pre-rendered grids take priority if they exist */
        if (showGrid(handle)) {
          e.preventDefault();
          setActive(pod);
          return;
        }

        /* Fetch-and-swap: only when there's a collection main section on this page */
        if (!findSection(document, '__main')) return; /* e.g. PDP -> normal navigation */

        e.preventDefault();
        if (busy) return;
        busy = true;
        setActive(pod);

        var main = findSection(document, '__main');
        var heading = findSection(document, '__section');
        if (main) main.style.opacity = '0.4';
        if (heading) heading.style.opacity = '0.4';

        fetch(href, { headers: { 'Accept': 'text/html' } })
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            if (swapFrom(doc)) {
              history.pushState({ vePods: true }, '', href);
              if (doc.title) document.title = doc.title;
              busy = false;
            } else {
              window.location.href = href;
            }
          })
          .catch(function () {
            window.location.href = href;
          });
      });
    });

    /* Back/forward: reload so the correct collection renders */
    if (!window.__vePodsPopstate) {
      window.__vePodsPopstate = true;
      window.addEventListener('popstate', function () {
        window.location.reload();
      });
    }

    /* On load, mark the pod matching a pre-rendered visible grid as active (legacy mode) */
    var visible = document.querySelector('[data-ve-fg-grid]:not([hidden])');
    if (visible) {
      var startHandle = visible.getAttribute('data-ve-fg-grid');
      pods.forEach(function (pod) {
        if (handleFromHref(pod.getAttribute('href')) === startHandle) {
          pod.classList.add('ve-pods__pod--active');
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["velvet-pdp-accordions"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ve-accordions').forEach(function (root) {
    if (root.dataset.veInit) return;
    root.dataset.veInit = '1';
    var dialog = root.querySelector('.ve-acc__lightbox');
    if (!dialog) return;
    var img = dialog.querySelector('.ve-acc__lightbox-img');
    root.querySelectorAll('.ve-acc__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        img.src = btn.dataset.veLightboxSrc;
        img.alt = btn.dataset.veLightboxAlt || '';
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.classList.contains('ve-acc__lightbox-close')) {
        dialog.close();
      }
    });
    dialog.addEventListener('close', function () {
      img.src = '';
    });
  });
  } catch(e) { console.error(e); }
})();

})();
